import { UseTranslationResponse, useTranslation } from "react-i18next"

export type UseTranslationsReturn = {
  appServer: UseTranslationResponse<"app_server", undefined>
  absences: UseTranslationResponse<"Absences", undefined>
  dataTypes: UseTranslationResponse<"DataTypes", undefined>
}

export function useTranslations(): UseTranslationsReturn {
  const appServer = useTranslation("app_server")
  const absences = useTranslation("Absences")
  const dataTypes = useTranslation("DataTypes")
  return { appServer, absences, dataTypes }
}
